export default __webpack_public_path__ + "static/media/short-para.bfc2cf4d.svg";